"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeocodeCacheToJSON = exports.GeocodeCacheFromJSONTyped = exports.GeocodeCacheFromJSON = void 0;
function GeocodeCacheFromJSON(json) {
    return GeocodeCacheFromJSONTyped(json, false);
}
exports.GeocodeCacheFromJSON = GeocodeCacheFromJSON;
function GeocodeCacheFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'expiresAt': json['expiresAt'],
        'formattedAddress': json['formattedAddress'],
        'geocodeResponse': json['geocodeResponse'],
    };
}
exports.GeocodeCacheFromJSONTyped = GeocodeCacheFromJSONTyped;
function GeocodeCacheToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'expiresAt': value.expiresAt,
        'formattedAddress': value.formattedAddress,
        'geocodeResponse': value.geocodeResponse,
    };
}
exports.GeocodeCacheToJSON = GeocodeCacheToJSON;
